import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { DeleteCanOutlineSvg } from './svgs';

export const IconDeleteCanOutline: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={DeleteCanOutlineSvg} viewBox="0 0 24 24" {...props} />;
};
